export default (el, parent) => {
  const { y: parentTop, height: parentHeight } = parent.getBoundingClientRect();

  const { y: elTop, height: elHeight } = el.getBoundingClientRect();

  return elTop >= parentTop && elTop + elHeight <= parentTop + parentHeight;
};
